import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ScheduleIntervalAction } from '../scheduleInterval.action';
import { ScheduleIntervalTranslator } from '../scheduleInterval.translator';

type IDependencies = IClientApiDependencySegment;

export const loadIntervalEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleIntervalAction.load.started),
  mergeMap((params) => {
    return dependencies.api.getScheduleIntervalList(params).pipe(
      mergeMap((response) => {
        const intervals = response.intervals ?? [];
        const result = intervals.map((interval, index) => {
          return ScheduleIntervalTranslator.fromApi(params.scheduleId, index, interval);
        });

        return [
          ScheduleIntervalAction.load.done({ params, result }),
        ];
      }),
      catchApiError((error) => {
        return [
          ScheduleIntervalAction.load.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
